export default {
  name: "Name",
  retailPrice: "MSRP",
  upc: "UPC",
  category: "Category",
  type: "Type",
  design: "Design Tags",
  description: "CompanyName",
  SalesPrice: "Sales Price",
  ListPrice: "List Price",
  ExtendedTotal: "Ext. Total",
  DontMaskPhone: true,
  AccountType: "Account Type",
  StoreType: "Store Type",
  Territory: "Territory",
  Region: "Region",
  StoreCategory: false,
  vendor: "Vendor",
  Shipping: "Freight",
  shipOn: "Ship Date",
  OpenTotal: "Open Total",
  ShippedTotal: "Shipped Total",
  TotalWeight: "Total Weight",
};
